import React, { useRef, useState } from "react";
import { KTSVG } from "../../../../_start/helpers";
import axios from "axios";
import Grid from "./Grid";
import Field from "./Field";
import { API_URL } from "../../../support/api";
import { MediaValidationErrors } from "../types/media";

const ACCEPT = [
	"image/png",
	"image/jpeg",
	"image/webp",
	"image/gif",
	"application/pdf",
].join(",");

type UploadModalProps = {
	handleFetchList: () => void;
};

export const UploadModal = ({ handleFetchList }: UploadModalProps) => {
	const [name, setName] = useState("");
	const [altText, setAltText] = useState("");
	const [caption, setCaption] = useState("");
	const [files, setFiles] = useState<FileList | null>(null);
	const [validationErrors, setValidationErrors] =
		useState<MediaValidationErrors>({});
	const closeRef = useRef<HTMLButtonElement>(null);

	const handleSubmit = async () => {
		setValidationErrors({});
		if (!files?.length) {
			setValidationErrors({ media: ["Select at least one file."] });
			return;
		}
		try {
			const formData = new FormData();
			formData.append("name", name);
			formData.append("alt_text", altText);
			formData.append("caption", caption);
			for (let i = 0; i < files.length; i++) {
				formData.append("media[]", files[i]);
			}
			const result = await axios.post(
				`${API_URL}/v1/media-library/store`,
				formData,
				{
					headers: { "Content-Type": "multipart/form-data" },
				}
			);
			if (result.data?.value?.success) {
				setName("");
				setAltText("");
				setCaption("");
				setFiles(null);
				handleFetchList();
				closeRef.current?.click();
			}
		} catch (error: unknown) {
			const err = error as { response?: { data?: { errors?: MediaValidationErrors } } };
			if (err?.response?.data?.errors) {
				setValidationErrors(err.response.data.errors);
			}
		}
	};

	return (
		<div className="modal fade" tabIndex={-1} id="custom_upload_kt_modal_1">
			<div className="modal-dialog">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title">Upload media</h5>
						<div
							className="btn btn-icon btn-sm btn-active-light-primary ms-2"
							data-bs-dismiss="modal"
							aria-label="Close"
						>
							<KTSVG
								path="/media/icons/duotone/Navigation/Close.svg"
								className="svg-icon svg-icon-2x"
							/>
						</div>
					</div>
					<div className="modal-body">
						<Grid>
							<Field>
								<div className="media-library-properties">
									<div className="media-library-field mb-3">
										<label className="form-label">Name</label>
										<input
											className="form-control form-control-solid"
											value={name}
											onChange={(e) =>
												setName(e.target.value)
											}
										/>
										{validationErrors.name?.map(
											(error) => (
												<p
													key={error}
													className="text-danger small mt-1"
												>
													{error}
												</p>
											)
										)}
									</div>
									<div className="media-library-field mb-3">
										<label className="form-label">
											Alt text
										</label>
										<input
											className="form-control form-control-solid"
											value={altText}
											onChange={(e) =>
												setAltText(e.target.value)
											}
										/>
										{validationErrors.alt_text?.map(
											(error) => (
												<p
													key={error}
													className="text-danger small mt-1"
												>
													{error}
												</p>
											)
										)}
									</div>
									<div className="media-library-field mb-3">
										<label className="form-label">
											Caption
										</label>
										<input
											className="form-control form-control-solid"
											value={caption}
											onChange={(e) =>
												setCaption(e.target.value)
											}
										/>
										{validationErrors.caption?.map(
											(error) => (
												<p
													key={error}
													className="text-danger small mt-1"
												>
													{error}
												</p>
											)
										)}
									</div>
									<div className="media-library-field mb-3">
										<label className="form-label">
											Files
										</label>
										<input
											type="file"
											className="form-control form-control-solid"
											accept={ACCEPT}
											multiple
											onChange={(e) =>
												setFiles(
													e.target.files || null
												)
											}
										/>
										{validationErrors.media?.map(
											(error) => (
												<p
													key={error}
													className="text-danger small mt-1"
												>
													{error}
												</p>
											)
										)}
									</div>
								</div>
								<button
									type="button"
									className="mt-5 btn btn-info btn-sm"
									onClick={handleSubmit}
								>
									Submit
								</button>
							</Field>
						</Grid>
					</div>
					<div className="modal-footer">
						<button
							ref={closeRef}
							type="button"
							className="btn btn-light"
							data-bs-dismiss="modal"
						>
							Close
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};
